import React from 'react'
import styled from 'styled-components'
import {LoadingLayer} from "../LoadingLayer";

type Block1Types = {
    className?: string
    title?: any,
    loading?: any,
    value: { mainText?: any, subText?: any }
}

function Block1(props: Block1Types) {

    return (
        <StyledBlock1 className={props.className}>
            <div className='key'><b>{props.title}</b></div>
            <div className='value'><b>{props?.value?.mainText + ' '} </b> {' ' + props?.value?.subText}</div>
            {props.loading && <LoadingLayer/>}
        </StyledBlock1>
    )
}


Block1.defaultProps = {
    key: 'Key',
    value: { mainText: 'mainText', subText: 'subText' }

}

const StyledBlock1 = styled.div`
  background: #FFCE00;
  font-size: 26px;
  font-family: "Open Sans";
  max-width: 454px;
  height: 115px;
  border-radius: 15px;
  box-sizing: border-box;
  display: flex;
  padding: 0 20px;
  filter: drop-shadow(0px 3px 6px rgba(39, 45, 59, 0.2));
  position: relative;

  .key {
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;


  }

  .value {
    justify-content: center;
    align-items: center;
    width: 50%;
    text-align: center;
    display: flex;
    font-size: 18px;

    b {
      font-size: 26px;
      margin-right: 20px;
    }
  }

`

export default Block1